import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { Flex, ButtonGroup, IconButton } from "@chakra-ui/react";

type Iprops = {
  onPrevClick: () => void;
  onNextClick: () => void;
  onPrevIsDisabled?: boolean;
  onNextIsDisabled?: boolean;
};

const StepperButtons = ({
  onPrevClick,
  onNextIsDisabled,
  onNextClick,
  onPrevIsDisabled,
}: Iprops) => {
  return (
    <Flex justifyContent="center" mb={"1rem"}>
      <ButtonGroup zIndex={1}>
        {onPrevIsDisabled ? (
          <IconButton
            aria-label="Next"
            variant={"secondary"}
            icon={<ChevronLeftIcon />}
            size={"lg"}
            isActive={true}
            borderRadius={".4rem"}
          />
        ) : (
          <IconButton
            aria-label="Previous"
            icon={<ChevronLeftIcon />}
            variant={"teronary"}
            onClick={onPrevClick}
            size={"lg"}
            isDisabled={onPrevIsDisabled}
          />
        )}
        {onNextIsDisabled ? (
          <IconButton
            aria-label="Next"
            variant={"secondary"}
            icon={<ChevronRightIcon />}
            size={"lg"}
            isActive={true}
            borderRadius={".4rem"}
          />
        ) : (
          <IconButton
            aria-label="Next"
            variant={"teronary"}
            icon={<ChevronRightIcon />}
            onClick={onNextClick}
            size={"lg"}
          />
        )}
      </ButtonGroup>
    </Flex>
  );
};

export default StepperButtons;
